import React from 'react'
import Nodata from '../NoData/NoData'
import Button from '../buttons/button'
import SearchComponent from '../Search Input/SearchComponent'
import CustomSelect from '../Select/CustomSelect'

const TableData = ({
  Heading,
  tableHeadings = [],
  showExtraHeading,
  data,
  searchTerm,
  setSearchTerm,
  showSearch = true,
  showExtraAdd = false,
  onAdd,
  addButtonLabel = 'Add',
  SubHeading,
  select1 = false,
  select2 = false,
  option1 = [],
  option2 = [],
  onSortByStatus,
  onSortByStatus2, placeholder, setPageNo = () => {}
}) => {
  return (
    <section className='space-y-2'>
      <div className='space-y-3 md:space-y-0 md:flex md:items-center md:justify-between'>
        <div>
          <h1 className='tableHeading'>{Heading}</h1>
          {/* {SubHeading && <p className='tableSubHeading'>{SubHeading}</p>} */}
        </div>
        <div className='flex gap-4 w-full md:w-auto'>
          {showExtraAdd && <Button onClick={onAdd}>{addButtonLabel}</Button>}
        </div>
      </div>

      <div className='grid grid-cols-1 md:grid-cols-2 gap-3 items-center'>
        <div className='md:w-64 lg:w-72 w-full'>
          {showSearch && (
            <SearchComponent
              placeholder={placeholder ? placeholder : `Search here ....`}
              value={searchTerm}
              onChange={e => { setSearchTerm(e.target.value); setPageNo(1) }}
            />
          )}
        </div>
        <div className='flex justify-end items-center gap-2'>
          {select1 && (
            <CustomSelect options={option1} onChange={onSortByStatus} />
          )}
          {select2 && (
            <CustomSelect options={option2} onChange={onSortByStatus2} />
          )}
        </div>
      </div>

      <div className='w-full rounded-lg mt-2'>
        {data && Array.isArray(data) && data.length > 0 ? (
          <>
            <div className='hidden w-full overflow-hidden border border-[#ebedf0] rounded-lg lg:block'>
              <table className='w-full text-left'>
                <thead className='rounded-t-lg bg-[#F1F5F9] border-b'>
                  <tr>
                    {tableHeadings.map((heading, index) => (
                      <th
                        key={index}
                        className='p-4 font-[600] text-[14px] text-left text-[#1D1F2C] whitespace-nowrap'
                      >
                        {heading}
                      </th>
                    ))}
                    {showExtraHeading &&
                      [...Array(Math.max(0, 10 - tableHeadings.length))].map(
                        (_, index) => (
                          <th key={index} className='px-4 py-4'></th>
                        )
                      )}
                  </tr>
                </thead>
                <tbody className='text-[#667085] divide-y divide-[#F0F1F3]'>
                  {data.map((row, index) => (
                    <tr
                      key={index}
                      className='text-[#667085] divide-y divide-[#F0F1F3] bg-white'
                    >
                      {row && Array.isArray(row) && row.length > 0 ? (
                        row.map((cell, cellIndex) => (
                          <td
                            key={cellIndex}
                            className='p-4 whitespace-nowrap text-[#1D1F2CCC] font-[500] text-[15px] capitalize'
                          >
                            {cell}
                          </td>
                        ))
                      ) : (
                        <td
                          colSpan={
                            tableHeadings.length + (showExtraHeading ? 5 : 0)
                          }
                          className='p-3 text-center text-gray-500 whitespace-nowrap'
                        >
                          No Data Available
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className='  lg:hidden space-y-4'>
              {data.map((row, index) => (
                <div
                  key={index}
                  className='bg-[#FFFFFF] rounded-lg border border-[#F0F1F3] shadow-md divide-y divide-[#F0F1F3]'
                >
                  {row && Array.isArray(row) && row.length > 0 ? (
                    row.map((cell, cellIndex) => (
                      <div
                        key={cellIndex}
                        className='flex justify-between items-center p-2'
                      >
                        <span className='text-xs font-medium text-[#202224]'>
                          {tableHeadings[cellIndex]}
                        </span>
                        <span className='text-sm font-medium text-black'>
                          {cell}
                        </span>
                      </div>
                    ))
                  ) : (
                    <div className='h-4 p-4 text-sm text-center text-gray-500'>
                      No Data Available
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        ) : (
          <div className='border border-[#9d9d9e69] rounded-md mt-2'>
            <Nodata
              nodataLabel={'Data Not Found'}
              nodataDesc={'Add New Coin here click to below button '}
              buttonLabel={' + Coin Management'}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default TableData
